import React from "react"
import game from "mindsters.png"

const Mindsters = props => <img src={game} className="game" {...props} />

export default Mindsters
